<template>
  <div class="col-md-11 col-lg-10 mx-auto py-2">
    <div
      class="col-12 text-left pb-3 d-flex justify-content-between align-items-center"
      :class="isMobile && 'px-0'"
    >
      <router-link
        :to="{ name: 'Home' }"
        class="text-left text-secondary font-weight-bold ml-2 mr-auto d-flex align-content-center"
      >
        <ArrowLeftLogo />
        <span>Torna alla home</span>
      </router-link>
      <!-- <div
        class="col-8 ml-auto mr-2"
        v-if="this.$route.params.tipo === 'paziente'"
      >-->
      <b-button
        v-if="this.$route.params.tipo === 'paziente'"
        variant="primary"
        @click="goToPrenota"
        class="my-2 font-weight-bold rounded-pill"
      >Prenota un consulto</b-button>
      <!-- </div> -->
    </div>

    <h1 class="pb-2">Il tuo calendario</h1>

    <div
      class="col-sm-12 col-lg-10 mx-auto"
      :class="isMobile && 'px-0'"
      v-if="this.$route.params.tipo === 'paziente'"
    >
      <b-overlay :show="loading" rounded="sm" spinner-variant="secondary">
        <b-container
          fluid
          class="col-12 bg-secondary border-secondary mx-auto border__div px-0 pt-0 pb-4 mb-2"
        >
          <h5 class="bg-secondary text-white rounded-top py-2 font-weight-bold">Questa Settimana</h5>
          <div
            class="d-flex text-white col-12 mx-auto py-2"
            :class="isMobile && 'flex-wrap'"
            v-if="showThisWeek"
          >
            <div
              class="d-flex flex-column px-0 mx-auto text-center"
              :class="isMobile ? 'col-4 my-2' : 'col-2'"
              v-for="day in days"
              :key="day"
            >
              <span class="mx-auto text-capitalize font-weight-bold mb-2">
                {{
                getDates(day) | moment("dddd D MMMM")
                }}
              </span>
              <div
                class="bg-white rounded text-secondary my-1 appuntamento point"
                v-for="(appuntamento, ind) in actual[day - 1]"
                :key="ind"
                @click="avvioConsultoPaziente(appuntamento.hashid)"
              >
                <p
                  v-if="appuntamento.confirmed"
                  class="m-0 font-weight-bold text-primary"
                >confermato</p>
                <p v-else class="m-0 font-weight-bold text-orange">in attesa</p>

                <p
                  class="m-0 font-weight-bold font__1"
                >{{ appuntamento.data_inizio | moment("HH:mm") }}</p>

                <p
                  class="m-0"
                  v-if="appuntamento.professionista && appuntamento.professionista.role == 'medico'"
                >Dr. {{ appuntamento.professionista.anagrafica.fullname }}</p>
                <p class="m-0" v-if="appuntamento.professionista && appuntamento.professionista.role == 'farmacista'">
                  Farmacia
                  {{ appuntamento.professionista.anagrafica.denominazione }}
                </p>
              </div>
            </div>
          </div>
          <p v-else class="text-white font-weight-bold">Nessun appuntamento per questa settimana</p>
        </b-container>
      </b-overlay>

      <b-overlay :show="loadingNext" rounded="sm" class="pt-3">
        <b-container
          fluid
          class="col-12 border-secondary bg-secondary mx-auto border__div px-0 pt-0 pb-4 mb-2"
        >
          <h5 class="py-2 font-weight-bold text-white">Prossima Settimana</h5>
          <div
            class="d-flex text-white col-12 mx-auto py-2"
            :class="isMobile && 'flex-wrap'"
            v-if="showNextWeek"
          >
            <div
              class="d-flex flex-column px-0 mx-auto text-center"
              :class="isMobile ? 'col-4 my-2' : 'col-2'"
              v-for="day in days"
              :key="day"
            >
              <span class="mx-auto text-capitalize font-weight-bold mb-2">
                {{
                getNextDates(day) | moment("dddd D MMMM")
                }}
              </span>
              <div
                class="bg-white rounded text-secondary my-1 appuntamento point"
                v-for="(appuntamento, ind) in seguente[day - 1]"
                :key="ind"
                @click="avvioConsultoPaziente(appuntamento.hashid)"
              >
                <p
                  v-if="appuntamento.confirmed"
                  class="m-0 font-weight-bold text-primary"
                >confermato</p>
                <p v-else class="m-0 font-weight-bold text-orange">in attesa</p>
                <p
                  class="m-0 font-weight-bold font__1"
                >{{ appuntamento.data_inizio | moment("HH:mm") }}</p>

                <p
                  class="m-0"
                  v-if="appuntamento.professionista && appuntamento.professionista.role == 'medico'"
                >Dr. {{ appuntamento.professionista.anagrafica.fullname }}</p>
                <p class="m-0" v-if="appuntamento.professionista && appuntamento.professionista.role == 'farmacista'">
                  Farmacia
                  {{ appuntamento.professionista.anagrafica.denominazione }}
                </p>
              </div>
            </div>
          </div>
          <p
            v-else
            class="text-white font-weight-bold"
          >Nessun appuntamento per la prossima settimana</p>
        </b-container>
      </b-overlay>

      <!-- storico -->

      <b-overlay :show="loading" rounded="sm" spinner-variant="secondary">
        <prenotazioni />
      </b-overlay>
    </div>

    <div
      class="col-sm-12 col-lg-10 mx-auto"
      :class="isMobile && 'px-0'"
      v-if="this.$route.params.tipo === 'professionista'"
    >
      <!-- <h4
        class="text-danger"
      v-if="user && !user.servizi_attivi.includes('1500-min-mese')"-->
      <h4 class="text-danger">{{ disableMsg }}</h4>
      <h4
        class="text-danger"
        v-if="user && user.servizi_attivi.length < 1"
      >Hai esaurito i minuti di teleconsulto disponibili per questo mese</h4>
      <b-overlay :show="loading" rounded="sm">
        <b-container
          fluid
          class="col-12 bg-secondary border-secondary mx-auto border__div px-0 pt-0 pb-4 mb-2"
        >
          <h5 class="py-2 font-weight-bold text-white">Questa Settimana</h5>
          <div
            class="d-flex text-white col-12 mx-auto py-2"
            v-if="showThisWeek"
            :class="isMobile && 'flex-wrap'"
          >
            <div
              class="d-flex flex-column px-0 mx-auto text-center"
              :class="isMobile ? 'col-4 my-2' : 'col-2'"
              v-for="day in days"
              :key="day"
            >
              <span class="mx-auto text-capitalize font-weight-bold mb-2">
                {{
                getDates(day) | moment("dddd D MMMM")
                }}
              </span>
              <div
                class="bg-white rounded text-secondary mb-1 pb-1 appuntamento point"
                v-for="(appuntamento, ind) in actual[day - 1]"
                :key="ind"
              >
                <div @click="avvioConsultoProfessionista(appuntamento.hashid)">
                  <p
                    class="m-0 font-weight-bold font__1"
                  >{{ appuntamento.data_inizio | moment("HH:mm") }}</p>
                  <p class="m-0">{{ appuntamento.paziente ? appuntamento.paziente.anagrafica.fullname : "utente eliminato"}}</p>
                </div>
                <confirm-btn :appuntamento="appuntamento" v-if="!disableBtn" />
              </div>
            </div>
          </div>
          <p v-else class="text-white font-weight-bold">Nessun appuntamento per questa settimana</p>
        </b-container>
      </b-overlay>
      <b-overlay :show="loadingNext" rounded="sm" class="pt-3">
        <b-container
          fluid
          class="col-12 bg-secondary border-secondary mx-auto border__div px-0 pt-0 pb-4 mb-2"
        >
          <h5 class="py-2 font-weight-bold text-white">Prossima Settimana</h5>
          <div
            class="d-flex text-white col-12 mx-auto py-2"
            v-if="showNextWeek"
            :class="isMobile && 'flex-wrap'"
          >
            <div
              class="d-flex flex-column px-0 mx-auto text-center"
              :class="isMobile ? 'col-4 my-2' : 'col-2'"
              v-for="day in days"
              :key="day"
            >
              <span class="mx-auto text-capitalize font-weight-bold mb-2">
                {{
                getNextDates(day) | moment("dddd D MMMM")
                }}
              </span>
              <div
                class="bg-white rounded text-secondary mb-1 pb-1 appuntamento point"
                v-for="(appuntamento, ind) in seguente[day - 1]"
                :key="ind"
              >
                <div @click="avvioConsultoProfessionista(appuntamento.hashid)">
                  <p
                    class="m-0 font-weight-bold font__1"
                  >{{ appuntamento.data_inizio | moment("HH:mm") }}</p>
                  <p class="m-0">{{appuntamento.paziente ? appuntamento.paziente.anagrafica.fullname : "utente eliminato"}}</p>
                </div>
                <confirm-btn :appuntamento="appuntamento" v-if="!disableBtn" />
              </div>
            </div>
          </div>
          <p
            v-else
            class="text-white font-weight-bold"
          >Nessun appuntamento per la prossima settimana.</p>
        </b-container>
      </b-overlay>

      <!-- storico -->

      <b-overlay :show="loading" rounded="sm" spinner-variant="secondary">
        <prenotazioni />
      </b-overlay>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import ConfirmBtn from "@/components/utilities/ConfirmBtn";
import Prenotazioni from "@/components/storico/Prenotazioni";
import ArrowLeftLogo from "@/../public/svg/arrow_left.svg";
export default {
  name: "CalendarioConsulti",
  components: {
    ConfirmBtn,
    Prenotazioni,
    ArrowLeftLogo
  },
  data() {
    return {
      user: null,
      elenco: null,
      elencoNext: null,
      utente: this.$route.params.tipo,
      oggi: moment().week(),
      days: 5,
      showThisWeek: true,
      showNextWeek: true,
      actual: [[], [], [], [], []],
      seguente: [[], [], [], [], []],
      loading: true,
      loadingNext: true,
      disableBtn: false,
      disableMsg: null
    };
  },
  computed: {
    isMobile: function() {
      return this.$root.device < 575;
    }
    // isActive:function(){
    //   if(this.user){
    //     var s
    //   }
    // }
  },
  methods: {
    fetchData() {
      var url =
        process.env.VUE_APP_VERSION +
        "consulto/all?settimana=" +
        moment().week();

      this.$axios
        .get(url)
        .then(res => {
          this.elenco = res.data.data;
          if (this.elenco.length == 0) {
            this.loading = false;
            return (this.showThisWeek = false);
          }
          Object.keys(this.elenco).map(el => {
            var date = new moment(this.elenco[el].data_inizio).day();
            this.actual[date - 1].push(this.elenco[el]);
          });

          this.loading = false;
        })
        .catch(err => {
          // console.log(err);
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    fetchNextWeek() {
      var week = moment().week() + 1;
      var url = process.env.VUE_APP_VERSION + "consulto/all?settimana=" + week;
      this.$axios
        .get(url)
        .then(res => {
          this.elencoNext = res.data.data;
          if (this.elencoNext.length == 0) {
            this.loadingNext = false;
            return (this.showNextWeek = false);
          }
          Object.keys(this.elencoNext).map(el => {
            var date = new moment(this.elencoNext[el].data_inizio).day();
            this.seguente[date - 1].push(this.elencoNext[el]);
          });
          this.loadingNext = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getDates(day) {
      return moment().day(day);
    },
    getNextDates(day) {
      return moment().day(day + 7);
    },
    goToPrenota() {
      this.$router.push({ name: "PrenotazioneConsulto" });
    },
    avvioConsultoPaziente(id) {
      //
      this.$router.push({ name: "AvvioConsultoPaziente", params: { rif: id } });
    },
    avvioConsultoProfessionista(id) {
      if (!this.disableBtn) {
        this.$router.push({
          name: "AvvioConsultoProfessionista",
          params: { rif: id }
        });
      }
    },
    getUser() {
      var url = process.env.VUE_APP_VERSION + "users/user";
      this.$axios
        .get(url)
        .then(res => {
          this.user = res.data.data;
          var abbonamento = res.data.data.abbonamento;
          if (!abbonamento) {
            this.disableBtn = true;
            console.log("+++++", this.disableBtn);
            this.disableMsg =
              "Il tuo abbonamento risulta non attivo. Non potrai effettuare teleconsulti";
          }

          // var abbonamenti = res.data.data.abbonamenti;
          // if (abbonamenti.length < 1) {
          //   this.disableBtn = true;
          //   this.disableMsg =
          //     "Il tuo abbonamento risulta non attivo. Non potrai effettuare teleconsulti";
          // } else {
          //   var latest = abbonamenti[abbonamenti.length - 1];
          //   if (latest.sottoscrizione.attivo == false) {
          //     this.disableBtn = true;
          //     this.disableMsg =
          //       "Il tuo abbonamento risulta non attivo. Non potrai effettuare teleconsulti";
          //   }
          // }
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    setAsSeen(){
      var url = process.env.VUE_APP_VERSION + "consulto/visualizzati?all=1";
      this.$axios
        .put(url)
        .then(() => {
          //
        })
        .catch((err) => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    }
  },
  created() {
    // console.log(moment().day(1));
    this.$route.params.tipo === "professionista" && this.getUser();
    this.fetchData();
    this.fetchNextWeek();
  },
  mounted(){
    this.setAsSeen();
  }
};
</script>
<style scoped>
.bg__lighted {
  background-color: #2b4473d9;
}
footer.modal-footer {
  display: none;
}
.appuntamento {
  border: 1px inset transparent;
}
.appuntamento:hover {
  border: 1px inset #2b4473;
  -webkit-box-shadow: inset 0px 0px 10px -7px rgba(43, 68, 115, 1);
  -moz-box-shadow: inset 0px 0px 10px -7px rgba(43, 68, 115, 1);
  box-shadow: inset 0px 0px 10px -7px rgba(43, 68, 115, 1);
}
</style>
